import React from "react";
import Layout from "../layouts/GeneralLayout";
import VisionBooking from "../screens/Vision/Vision";
import Toaster from "../components/Toaster";
import css from "../style/Layout.module.css";

const MobileVisionPage = () => {
  return (
    <Layout header={true} footer={true} visionFlow>
      <div className={css.visionFlowInner}>
        <Toaster>
          <VisionBooking />
        </Toaster>
      </div>
    </Layout>
  );
};

export default MobileVisionPage;
